export default __webpack_public_path__ + "static/media/ic_perks_48px.76859685.svg";